export default __webpack_public_path__ + "static/media/silver-volume-ar.bfe21ccd.png";